import {ShowInvoices} from './show-invoices';

export default ShowInvoices;
